import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { ValidateVOCTokenUseCase } from './ValidateVOCTokenUseCase';

export const initializeNotificationsUseCases = (container: Container) => {
    container.register(DI.USECASES.IValidateVOCTokenUseCase, {
        useClass: ValidateVOCTokenUseCase,
    });
};
